import PresultPublicPageBodyAdZone from "./PresultPublicPageBodyAdZone";

export default {
    'prp_1_1': PresultPublicPageBodyAdZone,
};